import { putACDetails } from "../services/alertConditions.service";
import { NotificationToaster } from "../utils/notificationToaster";

const updateACDetails = (clientId, data) => (dispatch, getState) => {
  const { acDetails } = getState().wizard;

  data.alertConditions = !!data.alertConditions ? data.alertConditions : "";
  const payload = {
    userID: clientId,
    ...data,
  };

  if (acDetails?.alertConditions !== payload?.alertConditions) {
    return putACDetails(payload)
      .then(() => {
        dispatch({ type: "UPDATE_AC_DETAILS", payload: data });
        return Promise.resolve();
      })
      .catch((err) => {
        dispatch({
          type: "UPDATE_ALERT_CONDITIONS_ERROR",
          payload: err.message,
        });
        NotificationToaster({ message: "Something went wrong", type: "error" });
      });
  } else {
    return Promise.resolve();
  }
};

export { updateACDetails };
